import { apiCall } from './generated/gqlClient';

const getAllOrdersApiRequest = async (startTime = null, endTime = null) => {
  const query = `
    query getAllOrders($startTime: DateTime, $endTime: DateTime) {
      getAllOrders(startTime: $startTime, endTime: $endTime) {
        items {
          id
          serviceId
          userMembershipId
          date
          price
          paid
          email
          clientName
          name
          paidWithUserMembershipId
          type
          metadata
          currency
          cancelled
          cancelledBy
          events {
            id
            orderId
            price
            paid
            channel
            method
            membershipId
            created
          }
        }
        profit {
          total
        }
        profitInSelectedPeriod {
          total
        }
      }
    }
  `;
  return apiCall({ query, variables: { startTime, endTime } });
};

const getMyOrdersApiRequest = async () => {
  const query = `
    query getMyOrders {
      getMyOrders {
        id
        name
        email
        type
        date
        productId
        subscriptionId
        reservationId
        price
        paid
        color
        duration
        sessions {
          id
          start_time
          end_time
          resource_name
        }
        timeUnit
        group_name
        resource_name
      }
    }
  `;
  return apiCall({ query });
};

const getUserOrdersApiRequest = async (userId, customerId) => {
  const query = `
    query getUserOrders($userId: Int, $customerId: Int) {
      getUserOrders(userId: $userId, customerId: $customerId) {
        items {
          id
          serviceId
          userMembershipId
          date
          price
          paid
          email
          clientName
          name
          paidWithUserMembershipId
          type
          metadata
          currency
          creditsUsed
          cancelled
          cancelledBy
          events {
            id
            orderId
            price
            paid
            channel
            method
            membershipId
            created
          }
        }
      }
    }
  `;
  return apiCall({ query, variables: { userId, customerId } });
};

export { getAllOrdersApiRequest, getMyOrdersApiRequest, getUserOrdersApiRequest };
